import React, { useEffect, useState } from "react";
import { adminPart2Responses } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { CHECKIN_FORM, EVALUATION_FORM, localize } from "@/data/part2Content";
import { getDayContent } from "@/pages/participant/part2Util";

function formLabels(day, lang) {
  const c = getDayContent(day, lang);
  const all = [localize(CHECKIN_FORM, lang), localize(EVALUATION_FORM, lang), ...(c ? [...c.forms, ...c.homework] : [])];
  return Object.fromEntries(all.map((f) => [f.id, { title: f.title, labels: Object.fromEntries(f.fields.map((x) => [x.id, x.label])) }]));
}

const FORM_ORDER = ["checkin", "evaluation"];

function ResponseTable({ rows, known }) {
  const keys = [...new Set(rows.flatMap((r) => Object.keys(r.answers || {})))];
  const labels = known || rows[0].labels || {};
  return (
    <div className="rbl-table-wrap">
      <table className="rbl-table">
        <thead><tr><th>Participant</th><th>Group</th><th>#</th>{keys.map((k) => <th key={k} style={{ minWidth: 140 }}>{labels[k] || k}</th>)}<th>Saved</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.user_id}-${r.form_id}`} data-testid={`p2-resp-row-${r.form_id}-${r.user_id}`}>
              <td>{r.user_name}<div style={{ color: "var(--muted)", fontSize: 12 }}>{r.email}</div></td>
              <td style={{ fontSize: 12 }}>{(r.groups || []).join(", ")}</td>
              <td>{r.form_id.split("__")[1] || 1}</td>
              {keys.map((k) => <td key={k} style={{ whiteSpace: "pre-line", minWidth: 140 }}>{String(r.answers?.[k] ?? "")}</td>)}
              <td style={{ fontSize: 12 }}>{(r.updated_at || "").slice(0, 16).replace("T", " ")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Part2Responses({ day }) {
  const { lang } = useApp();
  const [rows, setRows] = useState(null);
  useEffect(() => { setRows(null); adminPart2Responses(day).then(setRows).catch(() => setRows([])); }, [day]);
  if (!rows) return null;
  const base = (id) => id.split("__")[0];
  const byForm = rows.reduce((acc, r) => ({ ...acc, [base(r.form_id)]: [...(acc[base(r.form_id)] || []), r] }), {});
  const known = formLabels(day, lang);
  const forms = Object.keys(byForm).sort((a, b) => (FORM_ORDER.indexOf(a) + 1 || 9) - (FORM_ORDER.indexOf(b) + 1 || 9));
  return (
    <div style={{ marginTop: 34 }} data-testid="p2-admin-responses">
      <h2 className="rbl-block-h">Responses — Day {day}</h2>
      {forms.length === 0 && <p style={{ color: "var(--muted)" }} data-testid="p2-admin-responses-empty">No responses yet.</p>}
      {forms.map((f) => (
        <div key={f} style={{ marginTop: 18 }} data-testid={`p2-admin-responses-${f}`}>
          <h3 style={{ marginBottom: 8 }}>{known[f]?.title || byForm[f][0].form_title || f} <span style={{ color: "var(--muted)", fontWeight: 400 }}>· {byForm[f].length} responses</span></h3>
          <ResponseTable known={known[f]?.labels} rows={[...byForm[f]].sort((a, b) => (a.user_name || "").localeCompare(b.user_name || "") || (Number(a.form_id.split("__")[1] || 1) - Number(b.form_id.split("__")[1] || 1)))} />
        </div>
      ))}
    </div>
  );
}
